module.exports = __webpack_public_path__ + "readerCode.png?c2099c6b98feee674d41fbdd27f4e6f2";